import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, input } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthService, LoginMenuComponent } from '../../../auth';
import { PreferencesMenuComponent } from '../preferences-menu/preferences-menu.component';
import { MenuGroup } from '../../models';
import { MenuService, SystemEnvironmentService, TranslationService } from '../../services';
import { BaseComponent } from '../base/base.component';
import { CustomerSelectComponent } from '../customer-select/customer-select.component';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrl: './top-menu.component.scss',
  imports: [
    RouterLink,
    RouterLinkActive,
    PreferencesMenuComponent,
    LoginMenuComponent,
    CustomerSelectComponent,
    AsyncPipe,
  ],
})
export class TopMenuComponent extends BaseComponent implements OnInit {
  protected readonly translationService = inject(TranslationService);
  protected readonly authService = inject(AuthService);
  protected readonly systemEnvironment = inject(SystemEnvironmentService);
  private readonly menuService = inject(MenuService);
  private readonly router = inject(Router);

  public readonly isScannerApp = input(false);
  public readonly requireCustomerId = input(false);

  /**
   * Whether this app offers the Light / Dark / Match Windows menu — see AppearanceMenuComponent.
   * Phase 1 of dark mode is TmsWeb and TmsAdmin; the portal and the scanners leave it off and keep
   * today's appearance, because nothing then sets the attribute the theme keys off.
   */
  public readonly showAppearance = input(false);

  isAuthenticated$: Observable<boolean>;
  menus$: Observable<MenuGroup[]>;
  protected navbarOpen = false;

  ngOnInit() {
    this.isAuthenticated$ = this.authService.isAuthenticated();
    combineLatest([this.router.events, this.isAuthenticated$])
      .pipe(this.untilDestroyed())
      .subscribe(([event, isAuthenticated]) => {
        if (
          event instanceof NavigationEnd &&
          isAuthenticated &&
          (this.authService.isAdmin || this.authService.isCustomer || !this.requireCustomerId())
        ) {
          this.menus$ = this.menuService.menus.pipe(
            this.untilDestroyed(),
            tap((menus: MenuGroup[]) => this.closeMenus(menus)),
          );
          this.navbarOpen = false;
        }
      });
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  openMenu(menus: MenuGroup[], menu: MenuGroup) {
    const open = !menu.open;
    this.closeMenus(menus);
    menu.open = open;
  }

  closeMenus(menus: MenuGroup[]) {
    menus.forEach((x: MenuGroup) => (x.open = false));
  }
}
